export abstract class BaseMapper<TDto, TModel> {
  public abstract fromDto(_from: TDto): TModel;

  public fromDtoList(dtos: TDto[]): TModel[] {
    return dtos.map((dto) => this.fromDto(dto));
  }
}

export abstract class BasePayloadMapper<TModel, TDto> {
  public abstract toPayload(_from: TModel): TDto;
}
